import _color from '@/assets/utils/color.js';
<template>
  <div class="mx-auto w-3/5">
    <vx-card>
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span></span>
        </div>
        <div class="column is-narrow" v-if="this.recid == '0'">
          <div style="width: 250px">
            <vs-button
              class="mr-3 mb-2"
              @click="onSearchTMOIN"
              disabled="disabled"
              >ดึงข้อมูล Inbound</vs-button
            >
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          v-if="acstate == 'EDIT'"
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>Outbound Number</span>
        </div>
        <div class="column is-narrow" v-if="acstate == 'EDIT'">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="number"
              :readonly="true"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>Inbound Number</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="tmoinsNumber"
              @blur="$v.tmoinsNumber.$touch()"
            />
            <p v-if="$v.tmoinsNumber.$error & $v.tmoinsNumber.$dirty">
              Please Enter Required Data with Correct Format
            </p>
          </div>
        </div>
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span>Item No</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 150px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="inbitemnum"
              :readonly="true"
            />
          </div>
        </div>
      </div>

      <div class="columns" v-if="acstate == 'ADD'">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>เลขที่ใบขนสินค้า</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-file"
              icon-no-border
              v-model="dclnumber"
            />
          </div>
        </div>
      </div>

      <!-- <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>ปลายทาง</span>
        </div>
        <div class="column is-narrow mt-2">
          <div style="width: 350px">
            <vs-select
              disabled="disabled"
              autocomplete
              v-model="pod"
              class="w-full -mt-2"
            >
              <vs-select-item
                v-for="impc in importers"
                :key="impc.code"
                :value="impc.code"
                :text="impc.code + '-' + impc.name"
              />
            </vs-select>
            <p v-if="$v.pod.$error & $v.pod.$dirty">
              Please Enter Required Data with Correct Format
            </p>
          </div>
        </div>
      </div> -->

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>ปลายทาง</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 150px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-users"
              icon-no-border
              @blur="
                $v.pod.$touch();
                onModes7();
              "
              v-model="pod"
            />
            <p v-if="$v.pod.$error & $v.pod.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
        <div class="column is-narrow">
          <div style="width: 410px">
            <vx-input-group>
              <vs-input
                icon-pack="feather"
                icon="icon-eye"
                icon-no-border
                v-model="podname"
                :readonly="true"
              />

              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button
                    color="success"
                    type="filled"
                    icon="search"
                    @click="searchPod"
                    >Search</vs-button
                  >
                </div>
              </template>
            </vx-input-group>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>เลขที่ใบตราส่งสินค้า 1</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-bookmark"
              icon-no-border
              v-model="mawb"
              @blur="$v.mawb.$touch()"
            />
            <p v-if="$v.mawb.$error & $v.mawb.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
        <div
          class="column is-narrow mt-3"
          style="width: 160px; text-align: right"
        >
          <span>เลขที่ใบตราส่งสินค้า 2</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-bookmark"
              icon-no-border
              v-model="hawb"
              :readonly="true"
              @blur="$v.hawb.$touch()"
            />
            <p v-if="$v.hawb.$error & $v.hawb.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>เที่ยวบิน</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-cloud"
              icon-no-border
              v-model="vesselname"
              @blur="$v.vesselname.$touch()"
            />
            <p v-if="$v.vesselname.$error & $v.vesselname.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
        <div
          class="column is-narrow mt-3"
          style="width: 160px; text-align: right"
        >
          <span>วันที่ส่งออก</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 150px">
            <flat-pickr
              :config="configdateTimePicker"
              v-model="dcldate"
              placeholder="วันที่ส่งออก"
              @blur="$v.dcldate.$touch()"
            />
            <p v-if="$v.dcldate.$error & $v.dcldate.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>รายละเอียดสินค้า</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 470px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="edescription"
              @blur="$v.edescription.$touch()"
            />
            <p v-if="$v.edescription.$error & $v.edescription.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>จำนวนหีบห่อ</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 120px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-package"
              icon-no-border
              v-model="itempck"
              @blur="$v.itempck.$touch()"
              :disable="true"
            />
            <p v-if="$v.itempck.$error & $v.itempck.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
        <div class="column is-narrow">
          <div style="width: 170px">
            <!-- Append Button -->
            <vx-input-group>
              <vs-input
                :readonly="true"
                icon-pack="feather"
                icon-no-border
                v-model="packagesCode"
                @blur="
                  $v.packagesCode.$touch();
                  onModes6();
                "
              />

              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button
                    disabled="disabled"
                    color="success"
                    type="filled"
                    icon="search"
                    @click="searchPacks"
                    >Search</vs-button
                  >
                </div>
              </template>
            </vx-input-group>
            <!-- /Append Button -->
            <p v-if="$v.packagesCode.$error & $v.packagesCode.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>

        <div
          class="column is-narrow mt-3"
          style="width: 140px; text-align: right"
        >
          <span>น้ำหนักรวมหีบห่อ</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 120px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-underline"
              icon-no-border
              v-model="itemgw"
              @blur="$v.itemgw.$touch()"
            />
            <p v-if="$v.itemgw.$error & $v.itemgw.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
        <div class="column is-narrow">
          <div style="width: 170px">
            <!-- Append Button -->
            <vx-input-group>
              <vs-input
                :readonly="true"
                icon-pack="feather"
                icon-no-border
                v-model="gwunit"
                @blur="
                  $v.gwunit.$touch();
                  onModes3();
                "
              />

              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button
                    disabled="disabled"
                    color="success"
                    type="filled"
                    icon="search"
                    @click="searchGwUnit"
                    >Search</vs-button
                  >
                </div>
              </template>
            </vx-input-group>
            <!-- /Append Button -->
            <p v-if="$v.gwunit.$error & $v.gwunit.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>TAX ID ของผู้ประสงค์ที่จะทำการโอนย้าย</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-type"
              icon-no-border
              v-model="taxid"
              @blur="$v.taxid.$touch()"
            />
            <p v-if="$v.taxid.$error & $v.taxid.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>

        <div
          class="column is-narrow mt-3"
          style="width: 160px; text-align: right"
          v-if="acstate == 'ADD'"
        >
          <span>ลำดับสาขา</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 150px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-home"
              icon-no-border
              v-model="branch"
              @blur="$v.branch.$touch()"
            />
            <p v-if="$v.branch.$error & $v.branch.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>ชื่อผู้ประสงค์ที่จะทำการโอนย้าย</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 470px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-users"
              icon-no-border
              v-model="nameonmawb"
            />
          </div>
        </div>
      </div>

      <!-- <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>ชื่อเจ้าของสินค้าของ HAWB</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 470px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-users"
              icon-no-border
              v-model="nameonhawb"
              @blur="$v.nameonhawb.$touch()"
            />
            <p v-if="$v.nameonhawb.$error & $v.nameonhawb.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div> -->

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>ประเภท</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 200px">
            <vs-select
              disabled="disabled"
              autocomplete
              v-model="tmotypesCode"
              class="w-full"
            >
              <vs-select-item
                v-for="tmotype in tmotypes"
                :key="tmotype.code"
                :value="tmotype.code"
                :text="tmotype.name"
              />
            </vs-select>
            <p v-if="$v.tmotypesCode.$error & $v.tmotypesCode.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>หมายเหตุ</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 450px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="remark"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 280px; text-align: right"
        >
          <span>สถานะ</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-activity"
              icon-no-border
              v-model="status"
              :readonly="true"
            />
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <!-- <vs-button
            class="mr-3 mb-2"
            @click="onSubmit"
            :disabled="$v.$anyError"
            >Submit</vs-button
          > -->
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>

    <vs-popup fullscreen title="ผู้ประกอบการ" :active.sync="popupActive2">
      <addresss
        v-if="popupActive2"
        :searchs="searchs"
        @recsel="recsel2"
      ></addresss>
    </vs-popup>
    <vs-popup fullscreen title="Gross Weight Unit" :active.sync="popupActive3">
      <gwunit v-if="popupActive3" @recsel="recsel3"></gwunit>
    </vs-popup>
    <vs-popup fullscreen title="Net Weight Unit" :active.sync="popupActive4">
      <nwunit v-if="popupActive4" @recsel="recsel4"></nwunit>
    </vs-popup>
    <vs-popup fullscreen title="Qty Unit" :active.sync="popupActive5">
      <qtyunit v-if="popupActive5" @recsel="recsel5"></qtyunit>
    </vs-popup>
    <vs-popup fullscreen title="Packs Unit" :active.sync="popupActive6">
      <packsunit v-if="popupActive6" @recsel="recsel6"></packsunit>
    </vs-popup>
    <vs-popup fullscreen title="CustomsPort" :active.sync="popupActive7">
      <customsports v-if="popupActive7" @recsel="recsel7"></customsports>
    </vs-popup>
    <vs-popup fullscreen title="Port of Discharge" :active.sync="popupActive9">
      <ports v-if="popupActive9" @recsel="recsel9"></ports>
    </vs-popup>
  </div>
</template>

<script>
import { required, decimal } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import addresss from "../businesspartners/grid.vue";
import gwunit from "../packages/grid.vue";
import nwunit from "../packages/grid.vue";
import qtyunit from "../packages/grid.vue";
import packsunit from "../packages/grid.vue";
import ports from "../customsports/grid.vue";
import customsports from "../customsports/grid.vue";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      proTypesId: 1,
      userRole: "",
      userId: "",
      businessPartnersCode: "",
      companyGroupsCode: "",
      inbitemnum: "",
      tmotypes: [],
      tmotypesCode: "",
      importers: [],
      tmoinsNumber: "",
      pol: "",
      polname: "",
      podname: "",
      pod: "",
      dclnumber: "",
      searchs: "ALL",
      popupActive2: false,
      popupActive3: false,
      popupActive4: false,
      popupActive5: false,
      popupActive6: false,
      popupActive7: false,
      popupActive8: false,
      popupActive9: false,
      inbfrom: "TMO_OUT",
      number: "",
      importer: "",
      importername: "",
      mawb: "",
      hawb: "",
      companysname: "",
      customersname: "",
      transmode_id: "4",
      vesselname: "",
      dcldate: "",
      edescription: "",
      itemqty: 0,
      qtyunit: "",
      itemnw: 0,
      nwunit: "",
      itemgw: 0,
      gwunit: "",
      itempck: 0,
      packagesCode: "",
      nameonhawb: "",
      nameonmawb: "",
      taxid: "",
      branch: "",
      remark: "",
      status: "",
      readonly: false,
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
      times: null,
      configTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
      },
    };
  },
  validations: {
    dcldate: {
      required,
    },
    // importer: {
    //   required,
    // },
    mawb: {
      required,
    },
    hawb: {
      required,
    },
    vesselname: {
      required,
    },
    edescription: {
      required,
    },
    // companysname: {
    //   required,
    // },
    itempck: {
      required,
      decimal,
    },
    packagesCode: {
      required,
    },
    itemgw: {
      required,
      decimal,
    },
    gwunit: {
      required,
    },
    // nameonmawb: {
    //   required
    // },
    // nameonhawb: {
    //   required,
    // },
    taxid: {
      required,
    },
    branch: {
      required,
    },
    // itemqty: {
    //   required,
    //   decimal,
    // },
    // qtyunit: {
    //   required,
    // },
    // itemnw: {
    //   required,
    //   decimal,
    // },
    // nwunit: {
    //   required,
    // },
    // pol: {
    //   required,
    // },
    pod: {
      required,
    },
    tmoinsNumber: {
      required,
    },
    tmotypesCode: {
      required,
    },
  },
  components: {
    Datepicker,
    addresss,
    gwunit,
    nwunit,
    qtyunit,
    packsunit,
    ports,
    customsports
  },
  props: ["acstate", "recid"],
  methods: {
    recsel9(val) {
      // console.log(val);
      this.popupActive9 = false;
      this.pol = val;
      setTimeout(() => {
        this.onModes9();
      }, 500);
    },
    searchPol: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive9 = true;
      }, 300);
    },
    onModes9: function () {
      // alert("Hi");

      if (this.pol == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.pol = "";
        this.polname = "";

        return;
      }

      const formData = {
        token: localStorage.getItem("token"),
        token2: localStorage.getItem("token2"),
        dbname: localStorage.getItem("dbname"),
        code: this.pol,
      };

      // console.log(formData);
      axios
        .post("/ApiGetPort2", formData)
        .then((res) => {
          // console.log(res);
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: res.data.message,
              text: res.data.message,
            });
            this.pol = "";
            this.polname = "";
          } else {
            this.polname = res.data.message.name;
            this.pol = res.data.message.code;
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error",
            text: err,
          });
          this.pol = "";
          this.polname = "";
        });
    },
    onSearchTMOIN2() {
      const formData = {
        token: localStorage.getItem("token"),
        token2: localStorage.getItem("token2"),
        dbname: localStorage.getItem("dbname"),
        inbfrom: "TMO_IN",
        number: this.tmoinsNumber,
      };

      axios
        .post("/ApiGetInTmo2", formData)
        .then((res) => {
          // console.log(res);
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Inbound Error",
              text: res.data.message,
            });
            this.tmoinsNumber = "";
            // this.clsd();
          } else {
            this.importer = res.data.message.importer;
            this.importername = res.data.message.importername;
            this.mawb = res.data.message.mawb;
            this.hawb = res.data.message.hawb;
            this.vesselname = res.data.message.vesselname;
            this.edescription = res.data.message.edescription;
            this.companysname = res.data.message.companysname;
            this.itempck = res.data.message.itempck;
            this.packagesCode = res.data.message.packagesCode;
            this.itemgw = res.data.message.itemgw;
            this.gwunit = res.data.message.gwunit;
            this.nameonmawb = res.data.message.nameonmawb;
            this.nameonhawb = res.data.message.nameonhawb;
            this.taxid = res.data.message.taxid;
            this.branch = res.data.message.branch;
            this.itemqty = res.data.message.itemqty;
            this.qtyunit = res.data.message.qtyunit;
            this.itemnw = res.data.message.itemnw;
            this.nwunit = res.data.message.nwunit;
            this.tmoinsNumber = res.data.message.number;
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error",
            text: err,
          });
        });
    },
    onSearchTMOIN() {
      this.popupActive8 = true;
    },
    async recsel8(val) {
      // console.log(val);
      this.popupActive8 = false;
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const formData = {
        skus_code: val,
      };

      const response = await axios.post(
        `${BASE_API_URL}/outbound-svc/inbdetails/getInbDetail`,
        formData,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response.data.message,
        });
      } else {
        this.mawb = response.data.mawb;
        this.hawb = response.data.hawb;
        this.edescription = response.data.edescription;
        this.companysname = response.data.companysname;
        this.itempck = response.data.itempck;
        this.packagesCode = response.data.packagesCode;
        this.itemgw = response.data.itemgw;
        this.gwunit = response.data.gwunit;
        this.itemqty = response.data.itemqty;
        this.qtyunit = response.data.qtyunit;
        this.itemnw = response.data.itemnw;
        this.nwunit = response.data.nwunit;
        this.tmoinsNumber = response.data.inbordersNumber;
        this.tmotypesCode = response.data.tmotypes_code;
        this.inbitemnum = response.data.itemnum;
      }
    },
    recsel4(val) {
      // console.log(val);
      this.popupActive4 = false;
      this.nwunit = val;
      setTimeout(() => {
        this.onModes5();
      }, 500);
    },
    searchNwUnit: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive4 = true;
      }, 300);
    },
    onModes4: function () {
      // alert("Hi");

      if (this.nwunit == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.nwunit = "";

        return;
      }

      const formData = {
        token: localStorage.getItem("token"),
        token2: localStorage.getItem("token2"),
        dbname: localStorage.getItem("dbname"),
        code: this.nwunit,
      };

      // console.log(formData);
      axios
        .post("/ApiGetQtyunit", formData)
        .then((res) => {
          // console.log(res);
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: res.data.message,
              text: res.data.message,
            });
            this.nwunit = "";
          } else {
            this.nwunit = res.data.message.code;
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error",
            text: err,
          });
          this.nwunit = "";
        });
    },
    recsel5(val) {
      // console.log(val);
      this.popupActive5 = false;
      this.qtyunit = val;
      setTimeout(() => {
        this.onModes5();
      }, 500);
    },
    searchQtyUnit: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive5 = true;
      }, 300);
    },
    onModes5: function () {
      // alert("Hi");

      if (this.qtyunit == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.qtyunit = "";

        return;
      }

      const formData = {
        token: localStorage.getItem("token"),
        token2: localStorage.getItem("token2"),
        dbname: localStorage.getItem("dbname"),
        code: this.qtyunit,
      };

      // console.log(formData);
      axios
        .post("/ApiGetQtyunit", formData)
        .then((res) => {
          // console.log(res);
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: res.data.message,
              text: res.data.message,
            });
            this.qtyunit = "";
          } else {
            this.qtyunit = res.data.message.code;
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error",
            text: err,
          });
          this.qtyunit = "";
        });
    },
    recsel3(val) {
      // console.log(val);
      this.popupActive3 = false;
      this.gwunit = val;
      setTimeout(() => {
        this.onModes3();
      }, 500);
    },
    searchGwUnit: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive3 = true;
      }, 300);
    },
    async onModes3() {
      // alert("Hi");

      if (this.gwunit == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.gwunit = "";

        return;
      }

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response4 = await axios.get(
        `${BASE_API_URL}/inbound-svc/packages/${this.gwunit.toUpperCase()}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
        this.gwunit = "";
      } else {
        this.gwunit = response4.data.code;
      }
    },
    recsel6(val) {
      // console.log(val);
      this.popupActive6 = false;
      this.packagesCode = val;
      setTimeout(() => {
        this.onModes6();
      }, 500);
    },
    searchPacks: function () {
      // console.log("searchFin");
      setTimeout(() => {
        this.popupActive6 = true;
      }, 300);
    },
    async onModes6() {
      // alert("Hi");

      if (this.packagesCode == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.packagesCode = "";

        return;
      }

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const response4 = await axios.get(
        `${BASE_API_URL}/inbound-svc/packages/${this.packagesCode.toUpperCase()}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response4.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response4.data.message,
        });
        this.packagesCode = "";
      } else {
        this.packagesCode = response4.data.code;
      }
    },
    recsel2(val) {
      // console.log(val);
      this.popupActive2 = false;
      this.importer = val;
      setTimeout(() => {
        this.onModes2();
      }, 500);
    },
    searchImporter: function () {
      // console.log("searchFin");
      this.atype = "consignee";
      setTimeout(() => {
        this.popupActive2 = true;
      }, 300);
    },
    onModes2: function () {
      // alert("Hi");

      if (this.importer == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.importer = "";
        this.importername = "";

        return;
      }

      const formData = {
        token: localStorage.getItem("token"),
        token2: localStorage.getItem("token2"),
        dbname: localStorage.getItem("dbname"),
        code: this.importer,
      };

      // console.log(formData);
      axios
        .post("/ApiGetAddress", formData)
        .then((res) => {
          // console.log(res);
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: res.data.message,
              text: res.data.message,
            });
            this.importer = "";
            this.importername = "";
          } else {
            this.importername = res.data.message.ename;
            this.importer = res.data.message.code;
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error",
            text: err,
          });
          this.importer = "";
          this.importername = "";
        });
    },
    recsel7(val) {
      // console.log(val);
      this.popupActive7 = false;
      this.pod = val;
      setTimeout(() => {
        this.onModes7();
      }, 500);
    },
    searchPod() {
      this.popupActive7 = true;
    },
    async onModes7() {
      if (this.pod == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter Required Data",
        });

        this.pod = "";
        this.podname = "";

        return;
      }

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        if (token) {
          this.popupActive2 = false;

          const response = await axios.get(
            `${BASE_API_URL}/inbound-svc/customsports/${this.pod.toUpperCase()}`,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data)

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
            this.pod = "";
            this.podname = "";
          } else {
            this.pod = response.data.code;
            this.podname = response.data.name;
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    clsd: function () {
      // this.importer = this.importername = this.mawb = this.hawb = this.vesselname = this.dcldate = this.edescription = this.companysname = this.packagesCode = this.gwunit = this.qtyunit = this.nwunit = this.nameonmawb = this.nameonhawb = this.taxid = this.branch = this.remark = this.dclnumber =
      //   "";

      // this.itempck = this.itemgw = this.itemqty = this.itemnw = 0;
      let vm = this;
      vm.$emit("grid");
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  async beforeCreate() {
    // console.log("beforecreate");
    const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    const formData = {
      inbfrom: "TMO_IN",
    };

    const response4 = await axios.post(
      `${BASE_API_URL}/outbound-svc/tmotypes/getTmotypesALL`,
      formData,
      {
        headers: { Authorization: "Bearer " + token.accessToken },
      }
    );

    if (!response4.data) {
      this.loading = false;
      this.$vs.notify({
        position: "top-right",
        color: "danger",
        title: "Error from Backend",
        text: response4.data.message,
      });
    } else {
      this.tmotypes = response4.data;
    }

    // const response = await axios.post(
    //   `${BASE_API_URL}/outbound-svc/customsports/getCustomsPorts`,
    //   formData,
    //   {
    //     headers: { Authorization: "Bearer " + token.accessToken },
    //   }
    // );

    // if (!response.data) {
    //   this.loading = false;
    //   this.$vs.notify({
    //     position: "top-right",
    //     color: "danger",
    //     title: "Error from Backend",
    //     text: response.data.message,
    //   });
    // } else {
    //   this.importers = response.data;
    // }
  },
  async created() {
    this.checkProfiles();
    // console.log(this.recid);
    // console.log("create");

    if (this.recid != "0") {
      // alert("Edit");
      this.readonly = true;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        const response = await axios.get(
          `${BASE_API_URL}/outbound-svc/tmoexs/${this.recid}`,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );
        // console.log(response.data)

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          this.number = response.data.number;
          this.mawb = response.data.mawb;
          this.hawb = response.data.hawb;
          this.vesselname = response.data.vesselname;
          this.dcldate = response.data.dcldate;
          this.edescription = response.data.edescription;
          this.itempck = response.data.itempck;
          this.packagesCode = response.data.packagesCode;
          this.itemgw = response.data.itemgw;
          this.gwunit = response.data.gwunit;
          this.nameonmawb = response.data.nameonmawb;
          this.nameonhawb = response.data.nameonhawb;
          this.taxid = response.data.taxid;
          this.branch = response.data.branch;
          this.remark = response.data.remark;
          this.dclnumber = response.data.dclnumber;
          this.status = response.data.status;
          this.pol = response.data.pol;
          this.pod = response.data.pod;
          this.podname = response.data.podname;
          this.tmotypesCode = response.data.tmotypesCode;
          this.tmoinsNumber = response.data.tmoinsNumber;
          this.inbitemnum = response.data.inbitemnum;
          setTimeout(() => {
            this.onModes7();
          }, 500);
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    } else {
      let vm = this;
      vm.readonly = false;
      this.gwunit = "KGM";
      // vm.clsd();
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
